import { render, staticRenderFns } from "./fabricReportBasic.vue?vue&type=template&id=2faa4b9b&"
import script from "./fabricReportBasic.vue?vue&type=script&lang=js&"
export * from "./fabricReportBasic.vue?vue&type=script&lang=js&"
import style0 from "./fabricReportBasic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports